/**
 * BTN ACTION
 * @param id
 * @param disabled
 * @param content
 */
function btnAction(id, disabled, content) {
    // disabled: true OR false
    var $content;

    if (content == "") {
        $content = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Aguarde';
    } else {
        $content = content;
    }
    $(id).attr("disabled", disabled).html($content);
}

/**
 * ALERTS INLINE
 * @param object
 * @param content
 * @param action
 */
function alertInline(object, content, action) {

    if (action == true) {
        $(object).html(content);

        $(object).fadeIn("slow", function () {
            $(this).removeClass("hidden");
        });

    } else if (action == false) {
        $(object).fadeOut("slow", function () {
            $(this).addClass("display-hide");
        });
    }

}

/**
 * OPEN MODAL
 * @param id
 */
function openModal(id) {
    $.magnificPopup.open({
        items: {
            src: id
        },
        type: 'inline',
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-zoom-in'
    });
}

/**
 * CLOSE MODAL
 */
function closeModal() {
    $.magnificPopup.close();
}

/**
 * URL
 * @param $path
 * @returns {string|*}
 */
function url($path) {
    var url = window.location.href;

    if (url.indexOf("lhost") != -1) {
        if ($path) {
            return CONF_URL_TEST + $path;
        }
        return CONF_URL_TEST;
    }

    if ($path) {
        return CONF_URL_BASE + $path;
    }

    return CONF_URL_BASE;
}


/**
 * URL THEME
 * @param $path
 * @returns {string}
 */
function theme($path) {
    var url = window.location.href;

    if (url.indexOf("lhost") != -1) {
        if ($path) {
            return CONF_URL_TEST + '/themes/' + CONF_VIEW_THEME + $path;
        }
        return CONF_URL_TEST + '/themes/' + CONF_VIEW_THEME;
    }

    if ($path) {
        return CONF_URL_BASE + '/themes/' + CONF_VIEW_THEME + $path;
    }

    return CONF_URL_BASE + '/themes/' + CONF_VIEW_THEME;
}

/**
 * ICON SPRITE
 * @param $icon
 * @param $class
 * @param $attr
 * @returns {string}
 */
function iconSprite($icon, $class, $attr) {
    return '<svg viewBox="0 0 100 100" class="' + $class + '" ' + $attr + '><use xlink:href="' + url() + '/shared/icons/sprite/sprite.svg#' + $icon + '"></use></svg>';
}

/**
 * GET URL BASE (não utilizando mais)
 * @returns {string}
 */
function getUrlBase() {
    if (location.hostname === "www.localhost") {
        return "http://www.localhost/thermas";
    } else {
        return "https://www.thermas.com.br";
    }
}

/**
 * GET PARAMS
 */
function getUrlParameter() {
    var url = $(location).attr('href');
    var parts = url.split("/");
    return parts;
}

/**
 * CHANGE ELEMENT HEIGHT
 * @param elm
 * @param callback
 */
function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight
    var newHeight;

    (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight !== newHeight) callback();
        lastHeight = newHeight;

        if (elm.onElementHeightChangeTimer) {
            clearTimeout(elm.onElementHeightChangeTimer);
        }

        elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
}

/**
 * ADD ZERO LEFT
 * @param num
 * @param len
 * @returns {string}
 */
function addZeroLeft(num, len) {
    var numberWithZeroes = String(num);
    var counter = numberWithZeroes.length;
    while(counter < len) {
        numberWithZeroes = "0" + numberWithZeroes;
        counter++;
    }
    return numberWithZeroes;
}

/**
 * SMOOTH SCROLL TO ANCHOR
 * use: data-achor="id_element_to_scroll"
 * @param id
 */
function scrollToAnchor(id){
    const destination = $("#" + id);
    $('html,body').animate({
        scrollTop: destination.offset().top
    },'slow');
}
$('body').on("click", "[data-anchor]", function(e) {
    e.preventDefault();
    var data = $(this).data();
    scrollToAnchor(data.anchor);
});


/**
 * BOOTSTRAP MODAL - CREATE OBJECT
 * @param id
 */
var modal;
function modalBootstrap(id) {
    modal = new bootstrap.Modal(document.getElementById(id), {
        keyboard: true
    });
}

/**
 * BOOTSTRAP MODAL - SHOW
 * @param $size
 * @param $title
 * @param $content
 * @param $nivel
 * @param $footer = false, true
 */
function modalBootstrapShow($size, $title, $content, $nivel=1, $footer) {
    var id = 'modal';
    if ($nivel > 1) {
        id = 'modal' + $nivel
    }

    //set modal
    var modalTitle = $("#" + id + " .modal-title");
    var modalContent = $("#" + id + " .modal-body");
    var modalDialog = $("#" + id + " .modal-dialog");
    var modalSize = $size;

    //set size
    modalDialog.removeClass("modal-sm").removeClass("modal-md").removeClass("modal-lg").removeClass("modal-xl").removeClass("modal-xxl");
    if ($size.length > 10) {
        modalDialog.addClass('modal-fullscreen-' + $size + '-down');
    } else {
        modalDialog.addClass("modal-" + modalSize);
    }

    if ($footer) {
        $("#" + id + " .modal-dialog .modal-footer").removeClass('d-none');
        $("#" + id + " .modal-dialog .modal-footer").html($footer);
    }

    //change content
    modalTitle.html($title);
    modalContent.html($content);

    modalBootstrap(id);
    modal.show();
}

/**
 * BOOTSTRAP MODAL - HIDE
 * @param $nivel
 * @param $event
 */
function modalBootstrapHide($nivel= 1) {
    var id = 'modal';
    if ($nivel > 1) {
        id = 'modal' + $nivel
    }
    modal.hide();
}

/**
 * TIMER CONTADOR
 * @param date
 * @param urlExpire
 * @param interval
 */
function countTimerExpire(date, urlExpire, interval = 1000) {

    var countDownDate = new Date(date).getTime();

    var timer = setInterval(() => {
        var now = new Date().getTime();
        var timeleft = countDownDate - now;

        var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

        if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0 ) {
            clearInterval(timer);
            if (urlExpire) {
                window.location.href = urlExpire;
                return;
            }
        }

        $('.counter-timer').html(addZeroLeft(hours, 2) + ':' + addZeroLeft(minutes, 2) + ':' + addZeroLeft(seconds, 2));

    }, interval);
}

/**
 * CONSULTA DE URL EM LOOPING
 * @param interval = MILESEGUNDOS (1000 = 1s)
 * @param urlConsult
 * @param urlAction
 * @param interval
 */
function loopingConsultUrl(urlConsult, urlAction, interval = 1000) {
    setInterval(() => {
        $.post(urlConsult, {action: urlAction}, function (response) {
            if (response.redirect) {
                window.location.href = response.redirect;
                return;
            }
        }, "json");
    }, interval);
}


/**
 * LOADER
 */
function loaderShow() {
    loader.fadeIn(200);
}
function loaderClose() {
    loader.fadeOut(200);
}
//data- loader
$("[data-loader]").click(function () {
    loader.fadeIn(200);
});